// src/index.js
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS import
import React from 'react';
import ReactDOM from 'react-dom/client'; // Import createRoot from react-dom/client
import App from './App'; // Import the App component

// Get the root element from the DOM
const rootElement = document.getElementById('root');

// Create a root using React 18's createRoot
const root = ReactDOM.createRoot(rootElement);

// Render the App component inside the root with StrictMode
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
